export function getFormFields(ingredient) {
  const formFields = [
    {
      label: "Code",
      name: "code",
      value: ingredient?.code,
      type: "text",
      grid: 4,
    },
    {
      label: "Ingredient",
      name: "ingredient",
      value: ingredient?.ingredient,
      type: "text",
      grid: 4,
    },
    {
      label: "Ingredient Note",
      name: "ingredientNote",
      value: ingredient?.ingredientNote,
      type: "text",
      grid: 4,
    },
    {
      label: "Source Category",
      name: "sourceCategory",
      value: ingredient?.sourceCategory,
      type: "text",
      grid: 4,
    },
    {
      label: "Product Platform",
      name: "productPlatform",
      value: ingredient?.productPlatform,
      type: "text",
      grid: 4,
    },
    {
      label: "Suppliers",
      name: "suppliers",
      value: ingredient?.suppliers,
      type: "text",
      grid: 4,
    },
    {
      label: "Sector",
      name: "sector",
      value: ingredient?.sector,
      type: "text",
      grid: 4,
    },
    {
      label: "Product Type",
      name: "productTypeAlpha",
      value: ingredient?.productTypeAlpha,
      type: "text",
      grid: 4,
    },
    {
      label: "Product Type 2",
      name: "productTypeBeta",
      value: ingredient?.productTypeBeta,
      type: "text",
      grid: 4,
    },
    {
      label: "Product Type 3",
      name: "productTypeGamma",
      value: ingredient?.productTypeGamma,
      type: "text",
      grid: 4,
    },
    {
      label: "Chemical Composition",
      name: "chemicalComposition",
      value: ingredient?.chemicalComposition,
      type: "text",
      grid: 4,
    },
    {
      label: "Chemical Composition Standardized",
      name: "chemicalCompositionStandardized",
      value: ingredient?.chemicalCompositionStandardized,
      type: "text",
      grid: 4,
    },
    {
      label: "Chemical Name Iupac",
      name: "chemicalNameIupac",
      value: ingredient?.chemicalNameIupac,
      type: "text",
      grid: 4,
    },
    {
      label: "Solubility Note",
      name: "solubilityNote",
      value: ingredient?.solubilityNote,
      type: "text",
      grid: 4,
    },
    {
      label: "Extraction Yield Percentage",
      name: "extractionYieldPercentage",
      value: ingredient?.extractionYieldPercentage,
      type: "text",
      grid: 4,
    },
    {
      label: "Solubility In Water",
      name: "solubilityInWater",
      value: ingredient?.solubilityInWater,
      type: "text",
      grid: 4,
    },
    {
      label: "Solubility Category",
      name: "solubilityCategory",
      value: ingredient?.solubilityCategory,
      type: "text",
      grid: 4,
    },
    {
      label: "Polarity",
      name: "polarity",
      value: ingredient?.polarity,
      type: "text",
      grid: 4,
    },
    {
      label: "Stability Ph Note",
      name: "stabilityPhNote",
      value: ingredient?.stabilityPhNote,
      type: "text",
      grid: 4,
    },
    {
      label: "Stability Ph Standardized",
      name: "stabilityPhStandardized",
      value: ingredient?.stabilityPhStandardized,
      type: "text",
      grid: 4,
    },
    {
      label: "Stability Temperature Note",
      name: "stabilityTemperatureNote",
      value: ingredient?.stabilityTemperatureNote,
      type: "text",
      grid: 4,
    },
    {
      label: "Stability Temperature Standardized",
      name: "stabilityTemperatureStandardized",
      value: ingredient?.stabilityTemperatureStandardized,
      type: "text",
      grid: 4,
    },
    {
      label: "Stability Light",
      name: "stabilityLight",
      value: ingredient?.stabilityLight,
      type: "text",
      grid: 4,
    },
    {
      label: "Stability Low Concentration",
      name: "stabilityLowConcentration",
      value: ingredient?.stabilityLowConcentration,
      type: "text",
      grid: 4,
    },
    {
      label: "Stability High Concentration",
      name: "stabilityHighConcentration",
      value: ingredient?.stabilityHighConcentration,
      type: "text",
      grid: 4,
    },
    {
      label: "Stability Unit",
      name: "stabilityUnit",
      value: ingredient?.stabilityUnit,
      type: "text",
      grid: 4,
    },
    {
      label: "Low Quantity",
      name: "lowQuantity",
      value: ingredient?.lowQuantity,
      type: "text",
      grid: 4,
    },
    {
      label: "High Quantity",
      name: "highQuantity",
      value: ingredient?.highQuantity,
      type: "text",
      grid: 4,
    },
    {
      label: "Optimal Quantity",
      name: "optimalQuantity",
      value: ingredient?.optimalQuantity,
      type: "text",
      grid: 4,
    },

    {
      label: "Efficacy 1",
      name: "efficacy1",
      value: ingredient?.efficacy1,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 1 Level",
      name: "efficacy1Level",
      value: ingredient?.efficacy1Level,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 1 Unit",
      name: "efficacy1Unit",
      value: ingredient?.efficacy1Unit,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 1 Note",
      name: "efficacyNote",
      value: ingredient?.efficacyNote,
      type: "text",
      grid: 4,
    },
    {
      label: "Eff Parameter 1",
      name: "effParameter1",
      value: ingredient?.effParameter1,
      type: "text",
      grid: 4,
    },
    {
      label: "Eff Parameter 1 Unit",
      name: "effParameter1Unit",
      value: ingredient?.effParameter1Unit,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 2",
      name: "efficacy2",
      value: ingredient?.efficacy2,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 2 Level",
      name: "efficacy2Level",
      value: ingredient?.efficacy2Level,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 2 Unit",
      name: "efficacy2Unit",
      value: ingredient?.efficacy2Unit,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 2 Note",
      name: "efficacy2Note",
      value: ingredient?.efficacy2Note,
      type: "text",
      grid: 4,
    },
    {
      label: "Eff Parameter 2",
      name: "effParameter2",
      value: ingredient?.effParameter2,
      type: "text",
      grid: 4,
    },
    {
      label: "Eff Parameter 2 Unit",
      name: "effParameter2Unit",
      value: ingredient?.effParameter2Unit,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 3",
      name: "efficacy3",
      value: ingredient?.efficacy3,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 3 Level",
      name: "efficacy3Level",
      value: ingredient?.efficacy3Level,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 3 Unit",
      name: "efficacy3Unit",
      value: ingredient?.efficacy3Unit,
      type: "text",
      grid: 4,
    },
    {
      label: "Efficacy 3 Note",
      name: "efficacy3Note",
      value: ingredient?.efficacy3Note,
      type: "text",
      grid: 4,
    },
    {
      label: "Eff Parameter 3",
      name: "effParameter3",
      value: ingredient?.effParameter3,
      type: "text",
      grid: 4,
    },
    {
      label: "Eff Parameter 3 Unit",
      name: "effParameter3Unit",
      value: ingredient?.effParameter3Unit,
      type: "text",
      grid: 4,
    },
    {
      label: "Microorganism",
      name: "microorganism",
      value: ingredient?.microorganism,
      type: "text",
      grid: 4,
    },
    {
      label: "Group Of Microorganisms",
      name: "groupOfMicroorganisms",
      value: ingredient?.groupOfMicroorganisms,
      type: "text",
      grid: 4,
    },
    {
      label: "Growth Inhibition",
      name: "growthInhibition",
      value: ingredient?.growthInhibition,
      type: "text",
      grid: 4,
    },
    {
      label: "Growth Inhibition Percentage",
      name: "growthInhibitionPercentage",
      value: ingredient?.growthInhibitionPercentage,
      type: "text",
      grid: 4,
    },
    {
      label: "Inhibition Zone",
      name: "inhibitionZone",
      value: ingredient?.inhibitionZone,
      type: "text",
      grid: 4,
    },
    {
      label: "EffectOnTaste",
      name: "effectOnTaste",
      value: ingredient?.effectOnTaste,
      type: "text",
      grid: 4,
    },
    {
      label: "Taste",
      name: "taste",
      value: ingredient?.taste,
      type: "text",
      grid: 4,
    },
    {
      label: "Time",
      name: "time",
      value: ingredient?.time,
      type: "text",
      grid: 4,
    },
    {
      label: "Log Reduction",
      name: "logReduction",
      value: ingredient?.logReduction,
      type: "text",
      grid: 4,
    },
    {
      label: "Mic",
      name: "mic",
      value: ingredient?.mic,
      type: "text",
      grid: 4,
    },
    {
      label: "Test Method",
      name: "testMethod",
      value: ingredient?.testMethod,
      type: "text",
      grid: 4,
    },
    {
      label: "Phase",
      name: "phase",
      value: ingredient?.phase,
      type: "text",
      grid: 4,
    },
    {
      label: "Other Technofunctionality",
      name: "otherTechnofunctionality",
      value: ingredient?.otherTechnofunctionality,
      type: "text",
      grid: 4,
    },
    {
      label: "Link",
      name: "link",
      value: ingredient?.link,
      type: "text",
      grid: 4,
    },
    {
      label: "Short Link",
      name: "shortLink",
      value: ingredient?.shortLink,
      type: "text",
      grid: 4,
    },
    {
      label: "First Author",
      name: "firstAuthor",
      value: ingredient?.firstAuthor,
      type: "text",
      grid: 4,
    },
    {
      label: "Authors",
      name: "authors",
      value: ingredient?.authors,
      type: "text",
      grid: 4,
    },
    {
      label: "Year",
      name: "year",
      value: ingredient?.year,
      type: "text",
      grid: 4,
    },
    {
      label: "Journal",
      name: "journal",
      value: ingredient?.journal,
      type: "text",
      grid: 4,
    },
    {
      label: "Volume And Issue",
      name: "volumeAndIssue",
      value: ingredient?.volumeAndIssue,
      type: "text",
      grid: 4,
    },
    {
      label: "Title",
      name: "title",
      value: ingredient?.title,
      type: "text",
      grid: 4,
    },
    {
      label: "Notes",
      name: "notes",
      value: ingredient?.notes,
      type: "text",
      grid: 4,
    },
    {
      label: "Abstract",
      name: "abstract",
      value: ingredient?.abstract,
      type: "text",
      grid: 12,
      multiline: true,
      maxRows: 6,
    },
  ];

  return formFields;
}
